import { Link } from "react-router-dom";
import { Panels } from "@/components/site/Panels";
import { AssetImage, DecorAccent } from "@/components/site/AssetImage";
import { PHONE, SMS_HREF } from "@/lib/assets";
import { EditableText } from "@/components/site/EditableText";

const BEATS = [
  { asset: "HOW_1", title: "Boxes at about fifty stores", body: "Local shops, schools and offices host a box for new, unwrapped toys." },
  { asset: "HOW_2", title: "Weekend pickup by volunteers", body: "Volunteers drive around on weekends to gather the full boxes." },
  { asset: "HOW_3", title: "Sorting at a Brooklyn church", body: "Toys are sorted by age and type, so every child gets something that fits." },
  { asset: "HOW_4", title: "Delivery to about fifteen pediatric oncology hospitals", body: "Across NYC and New Jersey, over two to three days." },
].map((b, i) => ({ ...b, testId: `how-it-works-beat-${i + 1}`, titleKey: `home.how.${i + 1}.title`, bodyKey: `home.how.${i + 1}.body` }));

export function HowItWorks() {
  return (
    <section id="how" aria-labelledby="how-heading" className="of-container py-16 sm:py-20" data-testid="how-it-works-section">
      <div className="flex items-end justify-between gap-6">
        <div>
          <p className="of-eyebrow">How it works</p>
          <h2 id="how-heading" className="sr-only">How it works</h2>
          <EditableText k="home.how.title" def="From a store box to a hospital bedside." as="p" className="mt-3 font-display text-3xl font-semibold text-[var(--pg-head)] sm:text-4xl" />
        </div>
        <DecorAccent asset="REINDEER" className="hidden sm:flex" />
      </div>
      <Panels items={BEATS} testId="how-it-works-panels" />
      <div className="mt-8 flex flex-wrap gap-3" data-testid="how-it-works-cta">
        <Link to="/donate" className="of-btn-donate" data-testid="how-donate-button">Donate</Link>
        <Link to="/get-involved" className="of-btn-soft" data-testid="how-get-involved-button">Get involved</Link>
      </div>
    </section>
  );
}

const GIFTS = [
  { asset: "BIG_PS5", title: "PS5 consoles", body: "A shared game can turn a long hospital afternoon into a good one." },
  { asset: "BIG_VISA", title: "Visa gift cards", body: "Lets older kids and families choose something that feels just right." },
  { asset: "BIG_GAMESTOP", title: "GameStop gift cards", body: "A favorite for teens who know exactly what they want to play." },
];

export function BigGifts() {
  return (
    <section aria-labelledby="big-gifts-heading" className="of-container py-16 sm:py-20" data-testid="big-gifts-section">
      <div className="flex items-end justify-between gap-6">
        <div>
          <p className="of-eyebrow">Big gifts</p>
          <h2 id="big-gifts-heading" className="mt-3 text-3xl font-semibold sm:text-4xl">The gifts teens ask for most.</h2>
          <p className="mt-3 max-w-2xl text-lg text-[#3B4A44]">
            If you'd like to give one of these, text or call <a href={SMS_HREF} className="font-semibold text-[var(--pg-ink)] underline underline-offset-4" data-testid="big-gifts-text-link">{PHONE}</a>.
          </p>
        </div>
        <DecorAccent asset="GINGERBREAD" className="hidden sm:flex" />
      </div>
      <ul className="mt-10 grid gap-5 md:grid-cols-3">
        {GIFTS.map((g) => (
          <li key={g.title} className="of-card overflow-hidden" data-testid={`big-gift-${g.asset.toLowerCase()}`}>
            <AssetImage asset={g.asset} size="lg" className="aspect-[16/10] w-full" testId={`big-gift-image-${g.asset.toLowerCase()}`} />
            <div className="p-6">
              <h3 className="text-xl font-semibold">{g.title}</h3>
              <p className="mt-2 text-[#3B4A44]">{g.body}</p>
            </div>
          </li>
        ))}
      </ul>
    </section>
  );
}
